/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fee: NonNullable<unknown>, amount: NonNullable<unknown> }} Carrier_Form_Gift_Shipping_PrepaidInputs */

const vi_carrier_form_gift_shipping_prepaid = /** @type {(inputs: Carrier_Form_Gift_Shipping_PrepaidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đơn quà: người đặt đã chuyển khoản ship ${i?.fee}đ. Tiền thu người nhận: ${i?.amount}đ.`)
};

/**

* @param {Carrier_Form_Gift_Shipping_PrepaidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_gift_shipping_prepaid = /** @type {((inputs: Carrier_Form_Gift_Shipping_PrepaidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_Gift_Shipping_PrepaidInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_gift_shipping_prepaid(inputs)
});